function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
import { executeOnSingleOrMultiple } from "../../../../Utils/Utils";
export var DivEvent = /*#__PURE__*/function () {
  function DivEvent() {
    _classCallCheck(this, DivEvent);
    this.selectors = [];
    this.enable = false;
    this.mode = [];
    this.type = "circle";
  }
  _createClass(DivEvent, [{
    key: "el",
    get: function get() {
      return this.elementId;
    },
    set: function set(value) {
      this.elementId = value;
    }
  }, {
    key: "elementId",
    get: function get() {
      return this.ids;
    },
    set: function set(value) {
      this.ids = value;
    }
  }, {
    key: "ids",
    get: function get() {
      return executeOnSingleOrMultiple(this.selectors, function (t) {
        return t.replace("#", "");
      });
    },
    set: function set(value) {
      this.selectors = executeOnSingleOrMultiple(value, function (t) {
        return "#".concat(t);
      });
    }
  }, {
    key: "load",
    value: function load(data) {
      var _ref, _data$ids;
      if (!data) {
        return;
      }
      var ids = (_ref = (_data$ids = data.ids) !== null && _data$ids !== void 0 ? _data$ids : data.elementId) !== null && _ref !== void 0 ? _ref : data.el;
      if (ids !== undefined) {
        this.ids = ids;
      }
      if (data.selectors !== undefined) {
        this.selectors = data.selectors;
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      if (data.mode !== undefined) {
        this.mode = data.mode;
      }
      if (data.type !== undefined) {
        this.type = data.type;
      }
    }
  }]);
  return DivEvent;
}();